// extracted by mini-css-extract-plugin
export default {"clickable":"Tag-module-a702c99371206c531e07"};